const MAX_FOLDER_NAME_LEN = 128
export default {
  computed: {
    maxFolderNameLength() {
      return MAX_FOLDER_NAME_LEN
    },
  },
  methods: {
    isValidFolderName(folderName) {
      return folderName && folderName.trim().length > 0 && folderName.trim().length <= MAX_FOLDER_NAME_LEN
    },
    folderForSelector(folder, options = {}) {
      return {
        id: folder.id,
        name: folder.name,
        disabled: options.disabled || false,
        message: options.message || null,
      }
    },
  },
}
